/**
 * One page of a list endpoint — mirrors `Shared.Kernel/PagedResult<T>` on the backend (10 §5). Every
 * list route in the API answers in this shape, so the data layer has a single thing to type against.
 */
export interface Paged<T> {
  items: T[];
  /** 1-based page number this payload corresponds to. */
  page: number;
  /** Maximum items per page the server applied — it may be smaller than requested (it caps at 100). */
  pageSize: number;
  /** Total items matching the query across every page. */
  totalCount: number;
}

/** Query-string parameters every paginated endpoint accepts. */
export interface PageParams {
  page?: number;
  pageSize?: number;
}

/** Total number of pages for a result, for pagination controls. */
export function pageCount<T>(result: Paged<T>): number {
  return result.pageSize <= 0 ? 0 : Math.ceil(result.totalCount / result.pageSize);
}

/** An empty page — useful as a placeholder while the first request is in flight. */
export function emptyPage<T>(pageSize = 20): Paged<T> {
  return { items: [], page: 1, pageSize, totalCount: 0 };
}
